import { ICON_REGISTRY } from '@mobileConstants'
import { MobileApp } from '@mobileTypes'
import { Box, Typography } from '@mui/material'

import { MobilePhoneFrame } from './frames/MobilePhoneFrame'
import { VectorIconRenderer } from '@mobileComponents/VectorIconRenderer/VectorIconRenderer'

interface MobileAppsPreviewProps {
  apps: MobileApp[]
  currentApp?: MobileApp | null
  highlightCurrentApp?: boolean
}

export const MobileAppsPreview = ({
  apps,
  currentApp,
  highlightCurrentApp = true,
}: MobileAppsPreviewProps) => {
  const allApps = currentApp ? [...apps.filter(a => a.id !== currentApp.id), currentApp] : apps

  return (
    <MobilePhoneFrame title='📱 Apps Preview'>
      <Box sx={{ padding: '16px', height: '100%', overflow: 'auto' }}>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'row',
            flexWrap: 'wrap',
            gap: '12px',
            justifyContent: 'space-between',
          }}
        >
          {allApps.map((app, index) => {
            const isCurrentApp = currentApp && app.id === currentApp.id
            const appBgColor = app.backgroundColor || '#7FB5B5'

            return (
              <Box
                key={app.id || `app-${index}`}
                sx={{
                  width: 'calc(33% - 12px)',
                  aspectRatio: '1',
                  padding: '12px',
                  backgroundColor: appBgColor,
                  borderRadius: '12px',
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: '6px',
                  position: 'relative',
                  border: isCurrentApp && highlightCurrentApp ? '2px solid #4CAF50' : 'none',
                }}
              >
                {isCurrentApp && highlightCurrentApp && (
                  <Box
                    sx={{
                      position: 'absolute',
                      top: 2,
                      right: 2,
                      backgroundColor: '#4CAF50',
                      color: 'white',
                      fontSize: '8px',
                      padding: '2px 4px',
                      borderRadius: '3px',
                      fontWeight: 'bold',
                    }}
                  >
                    NEW
                  </Box>
                )}

                <Box
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    minHeight: '32px',
                  }}
                >
                  <VectorIconRenderer icon={app.icon} />
                </Box>

                <Typography
                  sx={{
                    color: 'white',
                    textAlign: 'center',
                    fontSize: '11px',
                    fontWeight: 500,
                    lineHeight: 1.2,
                    wordBreak: 'break-word',
                    overflow: 'hidden',
                    display: '-webkit-box',
                    WebkitLineClamp: 2,
                    WebkitBoxOrient: 'vertical',
                  }}
                >
                  {app.name || 'Untitled'}
                </Typography>
              </Box>
            )
          })}

          {allApps.length === 0 && (
            <Box
              sx={{
                width: '100%',
                padding: '40px 20px',
                textAlign: 'center',
                color: 'text.secondary',
              }}
            >
              <Typography variant='body2'>No apps yet</Typography>
            </Box>
          )}
        </Box>
      </Box>
    </MobilePhoneFrame>
  )
}
